export const GENERAL_KENOBI = {
	altgif:"image-type",
	altimage:"image-type",
	creativeimage:"image-type",
	native_image:"image-type",
	nativeimage:"image-type",
	facebookimage:"facebook-type",

	"html onpage":"html-type",
	html_expand:"html-type",
	html_onpage:"html-type",
	html_standard:"html-type",
	onpage:"html-type",
	onpage_standard:"html-type",
	"onpage standard":"html-type",
	standard_onpage:"html-type",
	display_html_tag:"html-type",

	vastaudio: "audio-type",

	dynamic_preroll:"video-type",
	dynamicprefoll:"video-type",
	vast_tag:"video-type",
	jsvpaid:"video-type",
	preroll:"video-type",
	vpaid:"video-type",
	vpaid_linear:"video-type",
	vpaid_nonlinear:"video-type",
	facebookvideo:"facebook-type",

	youtubevideo:"youtube-type",
	youtubeinstream:"youtube-type",
	youtubediscovery:"youtube-type",

	pixel:"pixel-tracking-type",
	track:"pixel-tracking-type",

	dtree:"dtree-type",
	modern_dtree:"modern-dtree-type",
	hedge:"hedge-type",
};

export function getCreativeClass(type){
	let cell = "";

	try {
		cell = GENERAL_KENOBI[type.toLowerCase()];
	} catch (err){}

	return `creative-${cell}`;
}
